import { Box, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

function Rango({ valorInicial, tipo, onChange }) {
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');

    useEffect(() => {
        try {
            if (valorInicial !== null) {
                // Elimina los corchetes y divide la cadena en una matriz
                const valores = valorInicial.substring(1, valorInicial.length - 1).split(';');
                //console.log(valores);

                // Convierte los valores a números
                let desdeInicial = valores[0].trim() === '*' ? '' : parseInt(valores[0].trim(), 10);
                let hastaInicial = valores[1].trim() === '*' ? '' : parseInt(valores[1].trim(), 10);

                if (isNaN(desdeInicial)) {desdeInicial = ''}
                if (isNaN(hastaInicial)) {hastaInicial = ''}

                // Verifica si los valores son números válidos
                if (!isNaN(desdeInicial) && !isNaN(hastaInicial)) {
                    setDesde(desdeInicial.toString());
                    setHasta(hastaInicial.toString());
                } else {
                    console.error('El valor inicial no contiene números válidos:', valorInicial);
                }
            }
        } catch (error) {
            console.error('Error al procesar el valor inicial:', error);
        }
    }, [valorInicial]);


    const handleDesdeChange = (e) => {
        const nuevoDesde = e.target.value;
        setDesde(nuevoDesde);
        onChange(nuevoDesde, hasta);
    };

    const handleHastaChange = (e) => {
        const nuevoHasta = e.target.value;
        setHasta(nuevoHasta);
        onChange(desde, nuevoHasta);
    };


    return (
        <Box sx={{ display: 'flex', gap: '16px' }}>
            <TextField type={tipo === 'fecha' ? 'date' : 'number'} value={desde} onChange={handleDesdeChange} label="Desde" />
            <Typography sx={{ alignSelf: 'center' }}>-</Typography>
            <TextField type={tipo === 'fecha' ? 'date' : 'number'} value={hasta} onChange={handleHastaChange} label="Hasta" />
        </Box>
    );
};

export default Rango;